import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { decrypt } from '../../../common/enc_dec';
import { course, enrollUser } from '../../../slices/courseSlice';
import CourseDetailsView from './courseDetailsView';
import EnrollmentReport from './enrolledUser';

const ViewReport = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { id } = location?.state || {};
    const queryParams = new URLSearchParams(location.search);
    const _id = decrypt(queryParams.get("id"));
    const courseId = id || _id;

    const { enrollUserList } = useSelector((state) => state.course);

    useEffect(() => {
        if (courseId) {
            dispatch(course({ id: courseId }));
            dispatch(enrollUser({ course_id: courseId }));
        }
    }, [dispatch, courseId]);

    return (
        <div className="content-page">
            <CourseDetailsView />

            {enrollUserList && (
                <div className="card mt-3 shadow-sm">
                    <div className="card-body">
                        <h5 className="card-title fw-semibold">👥 Enrollment Summary</h5>
                        <p className="card-text text-muted">
                            <EnrollmentReport/>
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewReport;
